<section class="wl-section">
  <div class="container">
    <h2 class="wl-title">{{ 'wishlist.title' | translate }}</h2>

    <p class="wl-empty" *ngIf="items.length === 0">{{ 'wishlist.empty' | translate }}</p>

    <div class="wl-grid" *ngIf="items.length > 0">
      <div class="wl-card" *ngFor="let item of items">
        <div class="wl-img" (click)="goToProduct(item.product_id)">
          <img
            *ngIf="item.product?.images?.length > 0"
            [src]="item.product.images[0].image_url"
            [alt]="item.product?.name"
          />
          <img
            *ngIf="!item.product?.images?.length"
            src="assets/images/rk.jpeg"
            alt="product"
          />
        </div>
        <div class="wl-info">
          <p class="wl-name" (click)="goToProduct(item.product_id)">{{ item.product?.name }}</p>
          <span class="wl-price-was" *ngIf="item.product?.discount > 0">{{ item.product?.price }} LE</span>
          <p class="wl-price">{{ effectivePrice(item.product) }} LE</p>
        </div>
        <button class="wl-remove-btn" (click)="remove(item.product_id)" title="Remove">
          <i class="ti-close"></i>
        </button>
      </div>
    </div>
  </div>
</section>
